import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  AgencyDashboardActionTypes, 
  GET_ORGANIZATIONAUTHORIZATION,
  GET_ORGANIZATIONENCOUNTER,
  GET_DASHBOARDDATA,
  GET_STAFFENCOUNTER, 
  GET_CHECKUSERPASSWORDSTATUS,
  GET_ORGANIZATIONSTAFFDOCUMENTS,
  GET_STAFFDOCUMENTS,
  GET_ORGANIZATIONCLIENTDOCUMENTS,
  GET_PATIENT,
  GET_MASTERDATABYNAME,
  GET_ORGANIZATIONBILLABLEHOURSGRAPH,
  GET_ORGANIZATIONOARESPONSES,
  GET_ORGANIZATIONFINANCIALKPIGRAPH,
  GET_ORGANIZATIONPAYERRESPONSES,
  GET_ExportCSVOrExcelOAREJECTIONS,
  GET_PayerResponsesExportAsCSVAndXLS,
  GET_CLIENTDOCUMENTS,
  GET_ExportCSVOrExcelStaffDocuments,
  GET_ExportCSVOrExcelClientDocuments,
  GET_ExportCSVOrExcelAppointmentDocuments,
  GET_ExportCSVOrExcelStaffNonAdminDocuments,
  GET_ExportCSVOrExcelClientNonAdminDocuments,
  GET_ExportCSVOrExcelAuthorizationDocuments,
  GET_CPTCODEFORAUTHORIZATION,
  GET_AUTHORIZATIONUTILIZATIONCHART,
  GET_AUTHORIZATIONSBYPATIENTID,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../actions/utilAction';

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyDashboardActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('Master Data response: ', response);
        dispatch(actionCreator(AgencyDashboardActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const getDashboardData = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyDashboardActionTypes.get_DashboardData.REQUEST));
    fetch(`${GET_DASHBOARDDATA}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_DashboardData.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getOrganizationAuthorization = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationAuthorization.REQUEST));
    fetch(`${GET_ORGANIZATIONAUTHORIZATION}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationAuthorization.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getOrganizationEncounter = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?pageNumber=${searchObj.pageNumber}&pageSize=${searchObj.pageSize}&sortColumn=${searchObj.sortColumn}&sortOrder=${searchObj.sortColumn}&fromDate=${searchObj.fromDate}&toDate=${searchObj.toDate}&searchText=${searchObj.searchText}`
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationEncounter.REQUEST));
    fetch(`${GET_ORGANIZATIONENCOUNTER}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationEncounter.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};



export const getStaffEncounters = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?pageNumber=${searchObj.pageNumber}&pageSize=${searchObj.pageSize}&sortColumn=${searchObj.sortColumn}&sortOrder=${searchObj.sortColumn}&fromDate=${searchObj.fromDate}&toDate=${searchObj.toDate}&searchText=${searchObj.searchText}`
    dispatch(actionCreator(AgencyDashboardActionTypes.get_StaffEncounter.REQUEST));
    fetch(`${GET_STAFFENCOUNTER}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_StaffEncounter.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const CheckUserPasswordStatus = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST));
    fetch(`${GET_CHECKUSERPASSWORDSTATUS}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response}));
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};

export const HideStaffPasswordStatusMessage = () => {  
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST));
  };
};

export const getOrganizationStaffDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationStaffDocuments.REQUEST));
    fetch(`${GET_ORGANIZATIONSTAFFDOCUMENTS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationStaffDocuments.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getOrganizationClientDocuments = (searchObj) => {
 
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
   
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationClientDocuments.REQUEST));
    fetch(`${GET_ORGANIZATIONCLIENTDOCUMENTS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationClientDocuments.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};



export const getStaffDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_StaffDocuments.REQUEST));
    fetch(`${GET_STAFFDOCUMENTS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_StaffDocuments.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getClientDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ClientDocuments.REQUEST));
    fetch(`${GET_CLIENTDOCUMENTS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_ClientDocuments.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};



export const getPatient = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnlyPermission}&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyDashboardActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENT}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(AgencyDashboardActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};


export const getOrganizationBillableHoursGraph = (searchObj) => {  
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);  
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationBillableHoursGraph.REQUEST));
    fetch(`${GET_ORGANIZATIONBILLABLEHOURSGRAPH}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationBillableHoursGraph.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getOrganizationOAResponses = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationOAResponses.REQUEST));
    fetch(`${GET_ORGANIZATIONOARESPONSES}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationOAResponses.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getOrganizationFinancialKPIGraph = (searchObj) => {  
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);  
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationFinancialKPIGraph.REQUEST));
    fetch(`${GET_ORGANIZATIONFINANCIALKPIGRAPH}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationFinancialKPIGraph.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getOrganizationPayerResponses = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationPayerResponses.REQUEST));
    fetch(`${GET_ORGANIZATIONPAYERRESPONSES}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_OrganizationPayerResponses.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getExportCSVOrExcelOARejections = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?fromDate=${searchObj.contain_filters.fromDate}&toDate=${searchObj.contain_filters.toDate}&extension=${searchObj.extension}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelOARejections.REQUEST));
    fetch(`${GET_ExportCSVOrExcelOAREJECTIONS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "ClearinghouseResponsesXls_data.xlsx" : "ClearinghouseResponsesCSV_data.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelOARejections.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getExportCSVOrExcelStaffDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortOrder=${searchObj.sort_order}&sortColumn=${searchObj. sort_fields}&extension=${searchObj.extension}&searchText=${searchObj.contain_filters.SearchText}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelStaffDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_StaffDocs.xlsx" : "Dashboard_StaffDocs.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getExportCSVOrExcelClientDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortOrder=${searchObj.sort_order}&sortColumn=${searchObj. sort_fields}&extension=${searchObj.extension}&searchText=${searchObj.contain_filters.SearchText}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelClientDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelClientDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_ClientDocs.xlsx" : "Dashboard_ClientDocs.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelClientDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getExportCSVOrExcelStaffNonAdminDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortColumn=${searchObj. sort_fields}&sortOrder=${searchObj.sort_order}&searchText=${searchObj.contain_filters.SearchText}&extension=${searchObj.extension}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffNonAdminDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelStaffNonAdminDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_StaffDocs.xlsx" : "Dashboard_StaffDocs.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelStaffNonAdminDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};


export const getExportCSVOrExcelClientNonAdminDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortColumn=${searchObj. sort_fields}&sortOrder=${searchObj.sort_order}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}&searchText=${searchObj.contain_filters.SearchText}&extension=${searchObj.extension}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelClientNonAdminDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelClientNonAdminDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_ClientDocs.xlsx" : "Dashboard_ClientDocs.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelClientNonAdminDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getExportCSVOrExcelAppointmentDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortColumn=${searchObj.sortColumn}&sortOrder=${searchObj.sortOrder}&fromDate=${searchObj.fromDate}&toDate=${searchObj.toDate}&searchText=${searchObj.searchText}&extension=${searchObj.extension}&isAdmin=${searchObj.isAdmin}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelAppointmentDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelAppointmentDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_Appts.xlsx" : "Dashboard_Appts.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelAppointmentDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getExportCSVOrExcelAuthorizationDocuments = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = `?sortOrder=${searchObj.sort_order}&sortColumn=${searchObj. sort_fields}&extension=${searchObj.extension}&searchText=${searchObj.contain_filters.SearchText}&viewTeamClientsOnly=${searchObj.viewTeamClientsOnly}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelAuthorizationDocuments.REQUEST));
    fetch(`${GET_ExportCSVOrExcelAuthorizationDocuments}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "Dashboard_Auth.xlsx" : "Dashboard_Auth.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_ExportCSVOrExcelAuthorizationDocuments.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};

export const getPayerResponsesExportAsCSVAndXLS = (searchObj) => {
  return (dispatch, getState) => {

    let query_params = `?fromDate=${searchObj.contain_filters.fromDate}&toDate=${searchObj.contain_filters.toDate}&extension=${searchObj.extension}`;
    dispatch(actionCreator(AgencyDashboardActionTypes.get_PayerResponsesExportAsCSVAndXLS.REQUEST));
    fetch(`${GET_PayerResponsesExportAsCSVAndXLS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(function checkHttpStatus(response) {
        if (response.status >= 200 && response.status < 204) {
          return response;
        } else if (response.status === 204) {
          return true;
        } else if (response.status >= 400 && response.status < 500) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(function(response) {
        return response.blob();
      })
      .then(function(response) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = url;
          const fileName = searchObj.extension === "XLS" ? "PayerResponsesXls_data.xlsx" : "PayerResponsesCSV_data.csv";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(actionCreator(AgencyDashboardActionTypes.get_PayerResponsesExportAsCSVAndXLS.SUCCESS));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  }
}

export const getCptCodeForAuthorization = (payload) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(payload);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_CptCodeForAuthorization.REQUEST));
    fetch(`${GET_CPTCODEFORAUTHORIZATION}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_CptCodeForAuthorization.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('cptCodeAuthorization error...', error);
      });
  };
};
export const getAuthorizationUtilizationChart = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_AuthorizationUtilizationChart.REQUEST));
    fetch(`${GET_AUTHORIZATIONUTILIZATIONCHART}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_AuthorizationUtilizationChart.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('cptCodeAuthorization error...', error);
      });
  };
};

export const getAuthorizationByPatientId = (searchObj) => {
  return (dispatch, getState) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    dispatch(actionCreator(AgencyDashboardActionTypes.get_AuthorizationByPatientId.REQUEST));
    fetch(`${GET_AUTHORIZATIONSBYPATIENTID}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(AgencyDashboardActionTypes.get_AuthorizationByPatientId.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get_app configuration error...', error);
      });
  };
};





// WEBPACK FOOTER //
// ./src/modules/Dashboards/actions/StaffDashboardActions.js